document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const selectedCategory = params.get('category');

  document.querySelectorAll('.brochure-item').forEach((item) => {
    const wrapper = item.querySelector('.brochure-item-wrapper');
    const panel = item.querySelector('.brochure-panel');
    const categorySpan = wrapper?.querySelector('.brochure-icon span');

    if (!wrapper || !panel) return;

    // if (
    //   selectedCategory &&
    //   categorySpan?.textContent?.trim() === selectedCategory
    // ) {
    //   openPanel(item, panel, true); // true = scroll
    // }
    if (
      selectedCategory &&
      categorySpan?.textContent?.replace(/\s+/g, ' ').trim().toLowerCase() ===
        selectedCategory.replace(/\s+/g, ' ').trim().toLowerCase()
    ) {
      openPanel(item, panel, true);
    }

    console.log(
      'brochure.js running, category=',
      selectedCategory,
      categorySpan.textContent
    );

    wrapper.addEventListener('click', () => {
      const isOpen = panel.classList.contains('active');
      closeAllPanels();
      if (!isOpen) {
        openPanel(item, panel, false); // false = no scroll
      }
    });
  });

  function closeAllPanels() {
    document.querySelectorAll('.brochure-item').forEach((item) => {
      item.classList.remove('active');
    });
    document
      .querySelectorAll('.brochure-panel')
      .forEach((p) => p.classList.remove('active'));
  }

  function openPanel(item, panel, shouldScroll) {
    panel.classList.add('active');
    item.classList.add('active');
    if (shouldScroll) scrollToHeading(item);
  }

  function scrollToHeading(item) {
    const heading = item.querySelector('.brochure-item-wrapper');
    if (heading) {
      setTimeout(() => {
        const headerOffset = 80;
        const elementPosition =
          heading.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }, 300);
    }
  }
});
